import { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import axiosInstance from '../components/lib/axiosInstance'
import IssueManagementContent from '../components/IssueManagementContent'
import { Issue } from '../components/commons'

const IssueManagementDetails = () => {
  const { phaseId } = useParams()

  const [data, setData] = useState<Issue[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/Issues/GetByPhase?PhaseId=${phaseId}`
        )
        setData(response?.data?.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    if (phaseId) {
      fetchData()
    }
  }, [phaseId])

  return <IssueManagementContent data={data} isLoading={isLoading} />
}

export default IssueManagementDetails
